import {
  Component,
  OnDestroy,
} from "@angular/core";

import { CommonModule } from "@angular/common";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule, MatMenuTrigger, MatMenu } from "@angular/material/menu";
import { MatIcon, MatIconModule } from "@angular/material/icon";
@Component({
  selector: "app-optimization-routes",
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatMenuModule,
    MatIcon,
    HoverMenuDirective,
    MatButtonModule
  ],
  templateUrl: "./optimization-routes.component.html",
  providers: [],
})
export class OptimizationRoutesComponent implements OnDestroy{

  ngOnDestroy(): void {
  }
}